import modelBase from "../model-base.model";
import ViewBase from "../../views/view-base.view";
import AttendanceWidget from "../../widgets/attendance.widget";
import SalesPerformanceWidget from "../../widgets/sales-performance.widget";
import SchedulesAndTasksWidget from "../../widgets/schedules-and-tasks.widget";
import VocWidget from "../../widgets/voc.widget";
import moment from 'moment';

var HomeDashboardModel = {

  getHomeWidgetLayoutSettings: function (successCallBack, failureCallBack) {
    const homeMenuId = 'WM000001';
    modelBase.get(successCallBack, failureCallBack, '/api/menu/widgetlayout?menuId=' + homeMenuId);
  },

  updateHomeWidgetLayoutSettings: function (successCallBack, failureCallBack, widgetList = []) {
    var params = {};
    params.menuId = 'WM000001';
    params.widgetList = widgetList;
    modelBase.post(successCallBack, failureCallBack, '/api/menu/widgetlayout', { body: params });
  },

  /**
   * For Attendance widget - start
   */

  getAttendanceWorkTypeData: function (successCallBack, failureCallBack) {
    modelBase.get(successCallBack, failureCallBack, '/api/attendance/worktype');
  },

  getAttendanceCheckInOutData: function (successCallBack, failureCallBack) {
    modelBase.get(successCallBack, failureCallBack, '/api/attendance/checkinout');
  },

  getAttendanceAbnormalData: function (successCallBack, failureCallBack) {
    modelBase.get(successCallBack, failureCallBack, '/api/attendance/abnormal');
  },

  /**
   * For Attendance widget - end
   */

  /**
   * For Sales Performance widget - start
   */

  getSalesPerformanceData: function (successCallBack, failureCallBack, retailDivList) {
    let filter = {};
    if (retailDivList && retailDivList.length > 0) {
      filter.retailDiv = retailDivList.join("^");
    }

    const qs = modelBase.toQueryString(filter);
    modelBase.get(successCallBack, failureCallBack, '/api/performance/sales?' + qs);
  },

  /**
   * For Sales Performance widget - end
   */

  /**
   * For Schedules & Tasks widget - start
   */

  getScheduleVisitStatusData: function (successCallBack, failureCallBack, filterDate) {
    let visitStatusDate = moment().format("YYYYMMDD"); // Default: today
    if (moment(filterDate, "YYYYMMDD", true).isValid()) {
      visitStatusDate = filterDate;
    } else if (filterDate) {
      console.error(`Invalid date format: ${filterDate}. Set to default: ${visitStatusDate}`);
    }
    modelBase.get(successCallBack, failureCallBack, `/api/schedule/visitstatus?Date=${visitStatusDate}`);
  },

  getTaskTypeAndStatusData: function (successCallBack, failureCallBack, filter = null) {
    let qs = '';
    if (filter) {
      qs = '?' + modelBase.toQueryString(filter);
    }
    modelBase.get(successCallBack, failureCallBack, '/api/todo/typeandstatus' + qs);
  },

  getTaskStoreStatusData: function (successCallBack, failureCallBack, filter = null) {
    let qs = '';
    if (filter) {
      qs = '?' + modelBase.toQueryString(filter);
    }
    modelBase.get(successCallBack, failureCallBack, '/api/todo/storestatus' + qs);
  },

  /**
   * For Schedules & Tasks widget - end
   */

  getWidgetById: function (widgetId) {
    ViewBase.call(this);
    switch (widgetId) {
      case 1:
        return m(AttendanceWidget);
      case 2:
        return m(SalesPerformanceWidget);
      case 4:
        return m(SchedulesAndTasksWidget);
      case 6:
        return m(VocWidget);
      default:
        console.error(`Widget not found. WIDGET_ID: ${widgetId}`);
        return m(".alert.alert-dark", `Widget not found. WIDGET_ID: ${widgetId}`); // [CV] TODO: REMOVE THIS OR CREATE A GENERIC ERROR MESSAGE
    }
  },

  compareWidgetSequence: function (obj1, obj2) {
    let seq1 = Number(obj1.sequence);
    let seq2 = Number(obj2.sequence);
    if (seq1 < seq2) {
      return -1;
    } else if (seq1 > seq2) {
      return 1;
    } else {
      return 0;
    }
  }
};

export default HomeDashboardModel;
